import { render, staticRenderFns } from "./AgencyEnglishTitleReadOnlyView.vue?vue&type=template&id=65a32c0b&scoped=true&"
import script from "./AgencyEnglishTitleReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./AgencyEnglishTitleReadOnlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a32c0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
installComponents(component, {VCardText})
